<po-page-list p-title="Pré-cadastro de clientes" [p-filter]="filter">
  <div class="po-m-5" style="text-align: right;">
    <po-button p-label="+ Cadastrar" (p-click)="onClick()" p-type="primary">
    </po-button>
  </div>

  <po-table
    p-sort="true"
    p-container="light"
    [p-columns]="columns"
    [p-items]="prospectList"
    [p-loading]="loading"
    [p-actions]="actions"
    p-container="shadow"
    p-height="300"
    p-striped="true"
    p-hide-text-overflow="true"
  >
  </po-table>
</po-page-list>
